import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-xxl section hero overflow-hidden" }
const _hoisted_2 = { class: "row align-items-center g-5" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "d-flex flex-wrap gap-3 mt-4" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "shape-stack mx-auto" }
const _hoisted_7 = { class: "container-xxl section" }
const _hoisted_8 = { class: "row g-4 justify-content-center" }
const _hoisted_9 = { class: "col-12 col-lg-10 col-xl-8" }
const _hoisted_10 = { class: "card roomy-card" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_15 = { class: "col-12 col-md-4" }
const _hoisted_16 = { class: "col-12 col-md-8" }
const _hoisted_17 = {
  key: 0,
  class: "alert alert-success mt-3"
}
const _hoisted_18 = {
  key: 1,
  class: "alert alert-danger mt-3"
}

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { submitLead, track } from '../composables/telemetry';
import { useToastStore } from '../stores/toast';


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const name = ref('');
const email = ref('');
const message = ref('');
const submitting = ref(false);
const sent = ref(false);
const error = ref<string | null>(null);
const toast = useToastStore();
const invalidEmail = computed(() => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value || ''));

// Respect reduced-motion preference for the decorative Lottie
const heroLottie = ref<any | null>(null);
const lottieError = ref(false);
const coinLottie = ref<any | null>(null);
const coinError = ref(false);
let motionMql: MediaQueryList | null = null;
let motionHandler: (() => void) | null = null;

onMounted(() => {
  motionMql = window.matchMedia('(prefers-reduced-motion: reduce)');
  const apply = () => {
    const player = heroLottie.value as any;
    if (!player || typeof player.pause !== 'function') return;
    if (motionMql?.matches) player.pause();
    else if (typeof player.play === 'function') player.play();
  };
  apply();
  if (motionMql) {
    if ('addEventListener' in motionMql) motionMql.addEventListener('change', apply);
    // Safari fallback
    // @ts-ignore
    else motionMql.addListener(apply);
    motionHandler = apply;
  }

  // Hide the player if it errors (e.g., missing asset)
  const playerEl = heroLottie.value as any;
  if (playerEl && typeof playerEl.addEventListener === 'function') {
    playerEl.addEventListener('error', () => { lottieError.value = true; });
  }

  const coinEl = coinLottie.value as any;
  if (coinEl && typeof coinEl.addEventListener === 'function') {
    coinEl.addEventListener('error', () => { coinError.value = true; });
  }
});

onBeforeUnmount(() => {
  if (motionMql && motionHandler) {
    if ('removeEventListener' in motionMql) motionMql.removeEventListener('change', motionHandler);
    // Safari fallback
    // @ts-ignore
    else motionMql.removeListener(motionHandler);
  }
});

async function submit() {
  submitting.value = true;
  error.value = null;
  try {
    await submitLead(name.value, email.value, message.value);
    sent.value = true;
    await track('lead_submitted', { email: email.value ? 'provided' : 'missing' });
    toast.push('success', 'Thanks! We\'ll be in touch.');
    name.value = email.value = message.value = '';
  } catch (e: any) {
    error.value = 'Something went wrong — try again';
    toast.push('error', error.value);
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lottie_player = _resolveComponent("lottie-player")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"eyebrow mb-2\"><span class=\"badge badge-tinted-primary border\">Non‑custodial · Testnet ready</span></div><h1 class=\"display-tight fw-bold mb-3\"> Launch a polished <span class=\"gradient-text\">DeFi swap</span> in minutes </h1><p class=\"lead text-muted-token\"> A brandable, production‑minded starter for token swaps. Connect your wallet, fetch quotes, and execute — all without custody. </p>", 3)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/swap",
              class: "btn btn-primary btn-lg"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "bi bi-lightning-charge me-2" }, null, -1),
                _createTextVNode("Launch demo ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/docs",
              class: "btn btn-outline-secondary btn-lg"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "bi bi-journal-text me-2" }, null, -1),
                _createTextVNode("Read docs ", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"d-flex flex-wrap gap-3 mt-4 small text-muted-token\"><span class=\"d-inline-flex align-items-center gap-1\"><i class=\"bi bi-shield-check\"></i>Non‑custodial</span><span class=\"d-inline-flex align-items-center gap-1\"><i class=\"bi bi-speedometer2\"></i>Fast quotes</span><span class=\"d-inline-flex align-items-center gap-1\"><i class=\"bi bi-palette\"></i>Brandable UI</span></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_lottie_player, {
              ref_key: "coinLottie",
              ref: coinLottie,
              class: "shape lottie coin",
              src: "/assets/3D%20Floating%20Spinning%20Coin.json",
              background: "transparent",
              speed: "0.05",
              loop: "",
              autoplay: "",
              "aria-hidden": "true"
            }, null, 512),
            _createVNode(_component_lottie_player, {
              ref_key: "heroLottie",
              ref: heroLottie,
              class: "shape lottie",
              src: "/assets/3D%20Shape%20Animation.json",
              background: "transparent",
              speed: "0.50",
              loop: "",
              autoplay: "",
              "aria-hidden": "true"
            }, null, 512)
          ])
        ])
      ])
    ]),
    _cache[10] || (_cache[10] = _createStaticVNode("<section class=\"container-xxl section\"><div class=\"row g-5\"><div class=\"col-md-4\"><div class=\"card h-100 roomy-card\"><div class=\"d-flex align-items-center gap-2 mb-2\"><i class=\"bi bi-box-seam fs-5 text-primary\"></i><h5 class=\"mb-0\">Plug‑and‑play</h5></div><p class=\"text-muted-token mb-0\">Vue 3 + TypeScript, Bootstrap styling, WalletConnect support — ready to fork and brand.</p></div></div><div class=\"col-md-4\"><div class=\"card h-100 roomy-card\"><div class=\"d-flex align-items-center gap-2 mb-2\"><i class=\"bi bi-shield-lock fs-5 text-primary\"></i><h5 class=\"mb-0\">Non‑custodial</h5></div><p class=\"text-muted-token mb-0\">Users remain in control of their wallets. Clear states and safe defaults.</p></div></div><div class=\"col-md-4\"><div class=\"card h-100 roomy-card\"><div class=\"d-flex align-items-center gap-2 mb-2\"><i class=\"bi bi-speedometer fs-5 text-primary\"></i><h5 class=\"mb-0\">Fast quotes</h5></div><p class=\"text-muted-token mb-0\">Fetch estimates from Uniswap‑style pools with straightforward, typed composables.</p></div></div></div></section><section class=\"container-xxl section\"><div class=\"row g-5 align-items-center\"><div class=\"col-lg-5\"><h2 class=\"fw-bold mb-2\">How it works</h2><p class=\"text-muted-token\">A concise flow built for clarity and speed. You can ship a clean demo and iterate quickly.</p></div><div class=\"col-lg-7\"><div class=\"row g-3\"><div class=\"col-sm-4\"><div class=\"p-4 rounded surface-2 h-100\"><div class=\"stat stat-lg\">1</div><div class=\"fw-semibold\">Connect</div><div class=\"small text-muted-token\">WalletConnect/AppKit or injected wallet.</div></div></div><div class=\"col-sm-4\"><div class=\"p-4 rounded surface-2 h-100\"><div class=\"stat stat-lg\">2</div><div class=\"fw-semibold\">Quote</div><div class=\"small text-muted-token\">Choose tokens and fetch an estimate.</div></div></div><div class=\"col-sm-4\"><div class=\"p-4 rounded surface-2 h-100\"><div class=\"stat stat-lg\">3</div><div class=\"fw-semibold\">Swap</div><div class=\"small text-muted-token\">Approve and submit on testnet.</div></div></div></div></div></div></section>", 2)),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "fw-bold mb-1" }, "Stay in the loop", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-muted-token mb-4" }, "Leave your email — we’ll share updates and roadmap invites.", -1)),
            _createElementVNode("form", {
              class: "row gy-3",
              onSubmit: _withModifiers(submit, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "input-group-text" }, [
                    _createElementVNode("i", { class: "bi bi-envelope" })
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    class: _normalizeClass(['form-control', invalidEmail.value ? 'is-invalid' : '']),
                    type: "email",
                    placeholder: "you@example.com",
                    "aria-label": "Email address"
                  }, null, 2), [
                    [
                      _vModelText,
                      email.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "submit",
                    disabled: submitting.value || invalidEmail.value
                  }, _toDisplayString(submitting.value ? 'Sending…' : 'Notify me'), 9, _hoisted_13)
                ]),
                (invalidEmail.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Please provide a valid email."))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
                  class: "form-control",
                  placeholder: "Name (optional)"
                }, null, 512), [
                  [
                    _vModelText,
                    name.value,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
                  class: "form-control",
                  placeholder: "Message (optional)"
                }, null, 512), [
                  [
                    _vModelText,
                    message.value,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ], 32),
            (sent.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Thanks! We’ll be in touch."))
              : _createCommentVNode("", true),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})